import { trackEvent } from 'arts/config/analytics';
import Constants from '../config/const';
import { importWallApi, loadFavoriteWallsApi } from '../config/api';
import { loadWorkDetails } from './works';
import { redo } from './undo';
import { resetZoom } from './canvas';

export const loadFavoriteWalls = () => (dispatch, getState) => {
  const { loaded, loading } = getState().favoriteWalls;
  if (loaded || loading) {
    return;
  }
  dispatch({ type: Constants.favoriteWalls.load });
  loadFavoriteWallsApi().then((walls) => {
    dispatch({ type: Constants.favoriteWalls.success, walls });
  }).catch(() => {
    dispatch({ type: Constants.favoriteWalls.success, walls: [] });
  });
};

export const addWallToCanvas = (sourceWallId) => (dispatch, getState) => {
  const { wallId, works } = getState().canvas;
  const previousWorks = [...works];
  const cachedDetails = getState().workDetails;

  importWallApi(wallId, sourceWallId).then((updatedWallPictures) => {
    dispatch(redo({
      type: Constants.canvas.setWorks,
      works: previousWorks
    }));
    dispatch({
      type: Constants.canvas.setWorks,
      works: updatedWallPictures
    });
    updatedWallPictures.forEach((wp) => {
      if (!cachedDetails[wp.workId]) {
        dispatch(loadWorkDetails(wp.workId));
      }
    });
    dispatch(resetZoom());
    trackEvent('wall builder: add wall from favorites', {
      'wall id': wallId,
      'source wall id': sourceWallId,
      'items count': updatedWallPictures.length - previousWorks.length
    });
  });
};
